"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOverDay = void 0;
const date_fns_1 = require("date-fns");
/**
 * Periodが日を跨いでいるかどうか
 * @param period
 */
const isOverDay = (period) => {
    return !(0, date_fns_1.isSameDay)(period.start, period.end);
};
exports.isOverDay = isOverDay;
//# sourceMappingURL=isOverDay.js.map